import React, { useState, useEffect  } from 'react';
import { Table as ReactTable } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { getProductGroups as getProductGroupsApi } from "../../../../../api/clients/productGroups";
import { TableRow } from "./TableRow";
import { TableHead } from "./TableHead";
import { DISCOUNT_TYPE } from "../../../../../config/constants/Campaign/campaign_constants";
import {
  IGNORED_PRODUCT_GROUPS_FOR_CAMPAIGN
} from "../../../../../config/constants/ProductGroups";

function TableComponent(props) {
  const {
    formikProps,
    isEditForm,
    initialValues,
    setInitialValues,
  } = props;
  const [ productGroups, setProductGroups ] = useState(null);
  const [ maxProds, setMaxProds ] = useState(1);
  const [ addedProdNums, setAddedProdNums ] = useState(1);
  const [ stateRows, setStateRows ] = useState([0]);

  useEffect(() => {
    getProductGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (formikProps.values.coupon_products.length >= 1) {
      setStateRows(Array.from({ length: formikProps.values.coupon_products.length }, (v, i) => i));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikProps.values.coupon_products])

  const getProductGroups = () => {
    getProductGroupsApi({ disablePagination: true }).then((response) => {
      if (response && response.data) {
        // Filter product groups, and remove items that should be removed for add coupon
        IGNORED_PRODUCT_GROUPS_FOR_CAMPAIGN.forEach(ignoredProductGroup => {
          response.data = response.data.filter(productGroup => productGroup.name !== ignoredProductGroup);
        });

        setProductGroups(response.data);
        let localOptions = {};
        let localMaxProds = 0;

        if (!isEditForm) {
          response.data.forEach(productGroup => {
            if (productGroup && productGroup.id) {
              if (!initialValues) {
                setInitialValues({});

                if ( !initialValues.coupon_products || typeof initialValues.coupon_products !== "object") {
                  setInitialValues({ coupon_products: [] });
                }
              }
            }

            if (localOptions && Object.keys(localOptions).indexOf(productGroup.id)) {
              localOptions[productGroup.id] = {};

              productGroup.products.forEach(product => {
                if (localOptions[productGroup.id] && Object.keys(localOptions[productGroup.id]).indexOf(product.id) && product.name !== 'custom-order') {
                  localOptions[productGroup.id][product.id] = product.name;
                  localMaxProds = localMaxProds + 1;
                }
              });
            }
          });

          setMaxProds(localMaxProds);
        }
      }
    });
  }

  const renderRows = () => {
    if ( !productGroups || !productGroups.length) {
      return null;
    }

    return stateRows.map((item, index) => {
      return <TableRow
        formikProps={ formikProps }
        productGroups={ productGroups }
        index={ index }
        key={ index }
        maxProds={ maxProds }
        addedProdNums={ addedProdNums }
        setAddRow={
          () => {
            let localRows = stateRows;
            localRows.push(stateRows.length)
            let localFormikProps = formikProps.values.coupon_products;
            localFormikProps.push({
              value: 0,
              product_group_id: "",
              product_id: "",
              discount_type: DISCOUNT_TYPE[0],
            });
            formikProps.setFieldValue("coupon_products", localFormikProps);

            setAddedProdNums(addedProdNums + 1);
            setStateRows(localRows);
          }
        }
        removeRow={
          index => {
            let localRows = stateRows;
            let localFormikProps = formikProps.values.coupon_products;

            localRows.splice(index, 1);
            localFormikProps.splice(index, 1);

            formikProps.setFieldValue("coupon_products", localFormikProps);

            setStateRows([...localRows]);
            setAddedProdNums(addedProdNums - 1);
          }
        }
      />
    });
  }

  return (
    <div className="reactstrap-overflow-visible campaign-coupon-product-table">
      <ReactTable responsive size="sm" className="add-coupons-table">
        <TableHead />
        <tbody>
        {
          renderRows()
        }
        </tbody>
      </ReactTable>
    </div>
  )
}

TableComponent.defaultProps = {
  isEditForm: false,
}

const Table = injectIntl(TableComponent);

export { Table, TableComponent }
